import React from 'react';
import { motion } from 'framer-motion';
interface RatingInputProps {
  label: string;
  value: number | null;
  onChange: (value: number) => void;
  error?: string;
  required?: boolean;
  min?: number;
  max?: number;
  minLabel?: string;
  maxLabel?: string;
}
export function RatingInput({
  label,
  value,
  onChange,
  error,
  required,
  min = 0,
  max = 10,
  minLabel = '0 = zeer ontevreden',
  maxLabel = '10 = zeer tevreden'
}: RatingInputProps) {
  const scale = Array.from({
    length: max - min + 1
  }, (_, i) => i + min);
  return <fieldset className="flex flex-col gap-3" data-id="element-6" data-mp="2beml3f68rejs">
      <legend className="text-[#0b2a4a] font-semibold text-sm md:text-base" data-id="element-7" data-mp="1wg0zzpdh26p1">
        {label} {required && <span className="text-red-500" data-id="element-8" data-mp="21ely9j95ygau">*</span>}
      </legend>

      <div className="flex flex-col gap-2" data-id="element-9" data-mp="21f41x0y5nwss">
        <div className="flex flex-wrap items-center gap-2" data-id="element-10" data-mp="3qtadds952cck">
          {scale.map(rating => {
          const isSelected = value === rating;
          return <motion.button key={rating} type="button" onClick={() => onChange(rating)} whileHover={{
            scale: 1.08
          }} whileTap={{
            scale: 0.92
          }} aria-pressed={isSelected} aria-label={`${rating} van ${max}`} className={`w-10 h-10 sm:w-11 sm:h-11 rounded-lg border text-sm font-semibold flex items-center justify-center transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#14b8a6] focus-visible:ring-offset-1 ${isSelected ? 'bg-[#0b2a4a] border-[#0b2a4a] text-white' : 'bg-white border-gray-200 text-[#0b2a4a] hover:border-[#14b8a6] hover:text-[#14b8a6]'}`} data-id="element-11" data-mp="3vqiudpijwac8">
                {rating}
              </motion.button>;
        })}
        </div>
        <div className="flex justify-between text-xs text-gray-500 px-0.5 max-w-[560px]" data-id="element-12" data-mp="2rl64duav5to4">
          <span data-id="element-13" data-mp="2njszpnjibwis">{minLabel}</span>
          <span data-id="element-14" data-mp="1k7c2bh5cwpdc">{maxLabel}</span>
        </div>
      </div>

      {error && <motion.span initial={{
      opacity: 0,
      y: -5
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-red-500 text-sm" data-id="element-15" data-mp="1p5x43l09bh3w">
          {error}
        </motion.span>}
    </fieldset>;
}